import { render } from "./FAQPage.vue?vue&type=template&id=157c3669&ts=true"
import script from "./FAQPage.vue?vue&type=script&lang=ts"
export * from "./FAQPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__